import { Stack } from '@mui/material';
import { useAuth0 } from '@auth0/auth0-react';
import { UserAvatar } from '@/components/shared/UserAvatar';

export const Body = () => {
  const { user } = useAuth0();
  return (
    <Stack direction="row" justifyContent="center">
      <UserAvatar name={user?.name} picture={user?.picture} sx={{ width: 100, height: 100 }} />
    </Stack>
  );
};
